import React, { FC } from 'react';
import { ConnectedRouter } from 'connected-react-router';
import { MuiThemeProvider, createTheme } from '@material-ui/core';
import '@devexpress/dx-react-chart-bootstrap4/dist/dx-react-chart-bootstrap4.css';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import postscribe from 'postscribe';

import './App.css';
import history from 'common/utils/history';
import AuthWrapper from 'components/AuthWrapper/AuthWrapper';

import useGaTracker from './useGaTracker';
import Routes from './Routes';
import { fontFamily } from './common/utils/constants';

if (process.env.REACT_APP_ENV === 'prod')
  postscribe(
    '#hubspot',
    ' <script type="text/javascript" id="hs-script-loader" async defer src="//js-na1.hs-scripts.com/24440991.js"></script>',
  );
localStorage.clear();
const theme = createTheme({
  palette: {
    primary: {
      main: '#EFF3F6',
      contrastText: '#FFFFFF',
      light: '#FF773F',
    },
    secondary: {
      main: '#FF6829',
      contrastText: '#FFFFFF',
      light: '#FF682980',
    },
    common: {
      black: '#000000',
      white: '#FFFFFF',
    },
    error: {
      main: '#FF0000',
      contrastText: '#121212',
      light: '#00000099',
      dark: '#E0987C',
    },
    warning: {
      main: '#F6FAFA',
      contrastText: '#121212',
      dark: '#000', // Duplicate
      light: '#00000099',
    },
    success: {
      main: '#75C24B',
      light: '#1EA59A1A',
      dark: '#93C9C7',
    },
    info: {
      main: '#FFD174',
      dark: '#808080',
      light: '#16192C',
    },
    grey: {
      50: '#404852',
      100: '#000', // Duplicate
      200: '#979797',
      300: '#464E5F',
      400: '#273240',
      500: '#262A41',
      600: '#222221',
      700: '#F3F6F9',
      800: '#FFC29F',
      900: '#EFF3F6', // Duplicate
      A100: '#FF6829', // Duplicate
      A200: '#0A6DF7',
      A400: '#818E9A',
      A700: '#F7F7F7',
    },
  },
  typography: {
    fontSize: 12,
    fontFamily: fontFamily,
  },
  shadows: [
    'none',
    '0px 18px 32px rgba(208, 210, 218, 0.15)',
    '3px 0px 6px rgba(0, 0, 0, 0.06)',
    '0px 9px 6px rgba(0, 0, 0, 0.06)',
    '0px 6px 6px rgba(0, 0, 0, 0.06)',
    '0px 4px 4px rgba(0, 0, 0, 0.25)',
    '0 1px 2px 0 rgba(32, 33, 36, 28%)',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
  ],
});
const App: FC = () => {
  useGaTracker();
  return (
    <div className="App">
      <MuiThemeProvider theme={theme}>
        <ConnectedRouter history={history}>
          <AuthWrapper>
            <Routes />
          </AuthWrapper>
        </ConnectedRouter>
      </MuiThemeProvider>
    </div>
  );
};
export default App;
